import "./App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HeroContext } from "./lib/HeroContext";

import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ServicesHub } from "./pages/ServicesHub";
import { ServiceDetailPage } from "./pages/ServiceDetailPage";
import { TechnologyPage } from "./pages/TechnologyPage";
import { ReviewsPage } from "./pages/ReviewsPage";
import { SmileGalleryPage } from "./pages/SmileGalleryPage";
import { FullMouthRehabilitationPage } from "./pages/FullMouthRehabilitationPage";
import { RestorativeDentistryPage } from "./pages/RestorativeDentistryPage";
import { SmileMakeoverPage } from "./pages/SmileMakeoverPage";
import { AestheticServicesPage } from "./pages/AestheticServicesPage";
import { BlogPage, BlogPostPage } from "./pages/BlogPage";
import { LocationPage } from "./pages/LocationPage";
import { ContactPage } from "./pages/ContactPage";
import { NotFoundPage } from "./pages/NotFoundPage";

function App() {
  const [hoveredPane, setHoveredPane] = useState(null);
  const [heroColor, setHeroColor] = useState("#bdbdbd");

  useEffect(() => {
    const blockContextMenu = (e) => {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", blockContextMenu);
    return () => document.removeEventListener("contextmenu", blockContextMenu);
  }, []);

  return (
    <HeroContext.Provider value={{ hoveredPane, setHoveredPane, heroColor, setHeroColor }}>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesHub />} />
            <Route path="/services/aesthetic-dentistry" element={<AestheticServicesPage />} />
            <Route path="/services/full-mouth-rehabilitation" element={<FullMouthRehabilitationPage />} />
            <Route path="restorative-dentistry" element={<RestorativeDentistryPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/services/:slug/:subslug" element={<ServiceDetailPage />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/gallery" element={<SmileGalleryPage />} />
            <Route path="/full-mouth-rehabilitation" element={<FullMouthRehabilitationPage />} />
            <Route path="/restorative-dentistry" element={<RestorativeDentistryPage />} />
            <Route path="/smilemakeover" element={<SmileMakeoverPage />} />
            <Route path="/aesthetic-services" element={<AestheticServicesPage />} />
            <Route path="/journal" element={<BlogPage />} />
            <Route path="/journal/:slug" element={<BlogPostPage />} />
            <Route path="/locations/:slug" element={<LocationPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
    </HeroContext.Provider>
  );
}

export default App;
